import { Gender } from 'common/types';

import { IdentityModuleDataQuery } from '../graphql/queries/identityModuleData.gql';
import { IdentitySchema } from './identitySchema';

/**
 * This function converts a userProfile from graphql into fields usable in the identity form.
 * Used to prefill the identity form fields.
 */
const getInitialFormValues = (
  profile: IdentityModuleDataQuery['viewer']['profile'],
): IdentitySchema => ({
  birthCity: profile.birthCity || '',
  birthCountry: profile.birthCountry || '',
  birthdate: profile.birthdate || '',
  birthDepartment: profile.birthDepartment || '',
  firstName: profile.firstName || '',
  gender: profile.gender === 'male' ? Gender.MALE : Gender.FEMALE,
  lastName: profile.lastName || '',
  nationality: profile.nationality || '',
});

export default getInitialFormValues;
